import React from 'react';
import styled, { css } from 'styled-components';

import { useTypedSelector } from '@/store/store';
import { selectSinglePost } from '@/store/reducers/single-post';
import { ContentContainer } from '@/modules/SinglePostDealerWeb/common.styles';
import { media } from '@/utils/mixin';
import { TextContent } from '@/components/LandingWidgets';

function Content() {
  const page = useTypedSelector(selectSinglePost);

  if (!page) {
    return null;
  }

  return (
    <Component id="post-content">
      <ContentContainer>
        <TextContent text={page?.body ?? ''} />
      </ContentContainer>
    </Component>
  );
}

export default Content;

const Component = styled.section`
  padding: 20px 0 30px;

  ${media.tablet(css`
    padding: 20px 0;
  `)}
`;
